module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="data block async no-button fieldset-scroll">\n    <legend>Menu</legend>\n    <div id="mealpicker-hook"></div>\n</fieldset>\n\n<fieldset class="data block async no-button">\n    <legend>Contacts</legend>\n    <div id="contacts-hook"></div>\n</fieldset>\n\n<button type="submit" class="button save">Save</button>\n<span class="hidden loadingBox">\n  Please wait...\n</span>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/layout.html
// module id = 272
// module chunks = 0